import { Box } from '@mui/material';
import { Button, Typography, colors } from '@sweep-io/sweep-design';

export interface PluginCardProps {
  svgIcon: React.ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  onAdd: () => void;
}

export const PluginCard = ({ svgIcon, title, description, onClick, onAdd }: PluginCardProps) => {
  return (
    <Box
      sx={{
        padding: '8px 16px',
        borderRadius: '4px',
        cursor: 'pointer',
        height: '100px',
        borderBottom: `1px solid ${colors.grey[200]}`,
        '& .plugin-button-on-hover': {
          display: 'none',
        },
        '&:hover': {
          backgroundColor: colors.grey[100],

          '& .plugin-button-on-hover': {
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          },
        },
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      onClick={onClick}
    >
      <Box display="flex" gap="16px" alignItems="start">
        <Box sx={{ '& svg': { width: '24px', height: '24px', marginTop: '5px' } }}>{svgIcon}</Box>
        <Box display="flex" flexDirection="column" gap="2px" overflow="hidden">
          <Typography variant="body" color={colors.grey[900]}>
            {title}
          </Typography>
          <Box
            sx={{
              overflow: 'hidden',
              '& .MuiTypography-root': {
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                whiteSpace: 'break-spaces',
                wordBreak: 'break-word',
              },
            }}
          >
            <Typography variant="body" color={colors.grey[700]}>
              {description}
            </Typography>
          </Box>
        </Box>
        <Box className="plugin-button-on-hover">
          <Button variant="system" onClick={onAdd} size="tiny">
            Add
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
